import { useState } from 'react'
import { FiMessageSquare, FiMoreVertical, FiCheckCircle, FiAlertCircle, FiClock, FiUser } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import './AgentCard.css'

const AgentCard = ({ agent, onClick }) => {
  const [showMenu, setShowMenu] = useState(false)
  const navigate = useNavigate()

  const statusConfig = {
    online: { color: 'success', icon: <FiCheckCircle />, label: 'Online' },
    offline: { color: 'muted', icon: <FiUser />, label: 'Offline' },
    busy: { color: 'warning', icon: <FiClock />, label: 'Busy' },
    away: { color: 'info', icon: <FiClock />, label: 'Away' },
    error: { color: 'danger', icon: <FiAlertCircle />, label: 'Error' }
  }

  const status = statusConfig[agent.status] || statusConfig.offline

  const handleMessageClick = () => {
    navigate(`/chat/${agent.agent_id}`)
  }

  const handleMenuClick = (action) => {
    setShowMenu(false)
    if (action === 'chat') navigate(`/chat/${agent.agent_id}`)
    else if (action === 'assign') navigate('/tasks')
  }

  return (
    <div className={`agent-card status-${status.color}`} onClick={onClick}>
      <div className="agent-header">
        <div className="agent-avatar">
          <div className="avatar-icon">
            {agent.name?.charAt(0) || 'A'}
          </div>
          <div className={`status-indicator ${status.color}`}>
            {status.icon}
          </div>
        </div>
        
        <div className="agent-info">
          <div className="agent-name">{agent.name}</div>
          <div className="agent-role">{agent.role}</div>
        </div>

        <div className="agent-actions">
          <button 
            className="action-btn message-btn"
            onClick={(e) => { e.stopPropagation(); handleMessageClick() }}
            title="Send message"
          >
            <FiMessageSquare />
          </button>
          
          <div className="menu-container">
            <button 
              className="action-btn menu-btn"
              onClick={(e) => { e.stopPropagation(); setShowMenu(!showMenu) }}
              title="More options"
            >
              <FiMoreVertical />
            </button>
            
            {showMenu && (
              <div className="dropdown-menu">
                <button onClick={() => handleMenuClick('view')}>View Details</button>
                <button onClick={() => handleMenuClick('assign')}>Assign Task</button>
                <button onClick={() => handleMenuClick('chat')}>Send Message</button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="agent-body">
        {agent.description ? (
          <div className="current-task">
            <div className="task-text">{agent.description}</div>
          </div>
        ) : (
          <div className="no-task">{agent.role} agent</div>
        )}
      </div>

      <div className="agent-footer">
        <div className="resource-stats">
          <div className="resource-item">
            <div className="resource-label">Role</div>
            <div className="resource-value">{agent.role}</div>
          </div>
          <div className="resource-item">
            <div className="resource-label">Status</div>
            <div className={`resource-value status-${status.color}`}>
              {status.label}
            </div>
          </div>
          <div className="resource-item">
            <div className="resource-label">ID</div>
            <div className="resource-value">{agent.agent_id?.split('-').slice(0, 2).join('-')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgentCard
